import Header from "./header";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const mapStateToProps = (state, nextState) => ({
  formulario: state.formularioReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
